var defineWellKnownSymbol = require('../internals/define-well-known-symbol');

// `Symbol.asyncIterator` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.asynciterator
defineWellKnownSymbol('asyncIterator');



//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/node_modules/core-js-pure/modules/es.symbol.async-iterator.js
// module id = 2617
// module chunks = 1